module.exports = __webpack_public_path__ + "img/misc2.eda84748.png";